import React from "react";
import { Pagination, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTranslations } from "next-intl";

interface PaginationProps {
  page: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  pageCount: number;
  totalCount: number;
  startIndex: number;
  endIndex: number;
  onFilterInteraction?: (filterType: string, filterValue: string | string[], action: "page") => void;
}

const TourSearchResultsPagination = ({
  page,
  handlePageChange,
  pageCount,
  totalCount,
  startIndex,
  endIndex,
  onFilterInteraction
}: PaginationProps) => {
  const t = useTranslations("SEARCH");
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handlePaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
    handlePageChange(event, value);
    onFilterInteraction?.("pagination", value.toString(), "page");
  };

  return (
    <Stack gap="1.6rem" alignItems="center">
      <Typography fontSize="1.6rem" data-testid="tour-search-results-pagination-label">
        {t("Pagination Label", {
          startIndex,
          endIndex,
          totalCount
        })}
      </Typography>
      <Pagination
        page={page}
        onChange={handlePaginationChange}
        color="primary"
        count={pageCount}
        siblingCount={isMobile ? 0 : 1}
        size="large"
        sx={{
          "& .Mui-selected": {
            "&:focus-visible": {
              backgroundColor: "primary.light"
            },
            "&:hover": {
              backgroundColor: "primary.light"
            }
          }
        }}
      />
    </Stack>
  );
};

export default TourSearchResultsPagination;